import { AdvManager } from '@doveconviene/sf-retail-media-library'
import {
  ONETRUST_TARGETING_CONSENT_GIVEN,
  SET_FLYER,
  setIsRetailMediaActive,
} from '../../actions'
import { selectFlyerIsActiveRetailMedia, selectIsConsentGiven, selectViewerFlyerId } from '../../selectors'
import { takeEvery } from '../helpers'

const initRMAdvManager = (dispatch, flyerIsActiveRetailMedia, isConsentGiven) => {
  const shouldShowRetailMedia = flyerIsActiveRetailMedia && isConsentGiven
  dispatch(setIsRetailMediaActive(shouldShowRetailMedia))
  if (!shouldShowRetailMedia && window.googletag) {
    /**
      // This call should destroy all slots
      https://developers.google.com/publisher-tag/reference?hl=it#googletag.destroySlots
    */
    if (window.googletag?.destroySlots) window.googletag?.destroySlots()
    return
  }

  AdvManager.init({
    advConf: {
      sizeMap: [[[300, 250], [728, 90], [320, 50]]],
      refreshTime: 0,
    },
  })
}

const onSetFlyer = ({ getState, dispatch }, action) => {
  const state = getState()

  const { flyer } = action.payload
  const flyerIsActiveRetailMedia = selectFlyerIsActiveRetailMedia(flyer.id)(state)

  const isConsentGiven = selectIsConsentGiven(state)
  initRMAdvManager(dispatch, flyerIsActiveRetailMedia, isConsentGiven)
}

const onOnetrustTargetingConsentGiven = ({ getState, dispatch }, action) => {
  const state = getState()

  const { targetingConsent: isConsentGiven } = action.payload

  const flyerId = selectViewerFlyerId(state)
  const flyerIsActiveRetailMedia = selectFlyerIsActiveRetailMedia(flyerId)(state)

  initRMAdvManager(dispatch, flyerIsActiveRetailMedia, isConsentGiven)
}

export default [
  takeEvery(SET_FLYER, onSetFlyer),
  takeEvery(ONETRUST_TARGETING_CONSENT_GIVEN, onOnetrustTargetingConsentGiven),
]
